<script setup lang="ts" name="FormWizardStep">
defineProps<{
  separator?: boolean;
}>();
</script>

<template>
  <div
    class="p-6"
    :class="{
      'border-b border-charcoal-2': separator,
    }"
  >
    <slot />
  </div>
</template>
